export default __webpack_public_path__ + "static/media/shoes7.422b893a.jpg";